export default __webpack_public_path__ + "static/media/08_DAIF_WHY_DELL_04_03_Loop.603da92c.mp4";